document.addEventListener('DOMContentLoaded', function () {
  const headers = document.querySelectorAll('.for-horeca__faq__inner__container__block__header');

  headers.forEach((header) => {
    header.addEventListener('click', function () {
      const content = this.nextElementSibling;
      const icon = this.querySelector('.for-horeca__faq__inner__container__block__header__icon');

      if (content.style.maxHeight) {
        content.style.maxHeight = null;
        icon.classList.remove('active');
      } else {
        content.style.maxHeight = content.scrollHeight + 'px';
        icon.classList.add('active');
      }
    });
  });
});
